import _ from 'lodash';
import { v4 as uuid } from 'uuid';
const BULK_SEARCH_TYPE = 'bulk';
const SINGLE_SEARCH_TYPE = 'single';
export function mapOrganization(organization) {
    return Object.assign({ name: organization.name, domain: organization.web, position: organization.position || '', time: organization.time, isCurrentJob: organization.is_current_job === 'YES', companyLid: organization.company_lid }, (organization.locality ? { locality: organization.locality } : {}));
}
export function mapCurrentPosition(currentPosition) {
    return {
        name: currentPosition.companyName,
        position: currentPosition.title,
        isCurrentJob: currentPosition.current,
        companyLid: currentPosition.company_lid,
    };
}
export function mapSingleSearchData(searchData, isPluginOpen) {
    const contactId = uuid();
    const data = searchData.data || searchData.parsedData || searchData; // old parsers returns parsedData
    return {
        metadata: {
            searchType: SINGLE_SEARCH_TYPE,
            requestId: searchData.request_id,
            parserType: searchData.metadata.parserType,
            isUnifiedParser: searchData.metadata.isUnifiedParser,
            isUnifiedParserEnabled: searchData.metadata.isUnifiedParserEnabled,
            sourcePlatform: data.source_platform,
            url: searchData.url,
            isPluginOpen,
            sessionId: searchData.sessionId,
            platform: searchData.metadata.platform,
            indicatorNotFound: searchData.metadata.indicatorNotFound,
            indicatorSelector: searchData.metadata.indicatorSelector,
            parserCategory: searchData.metadata.parserCategory,
            status: searchData.status,
        },
        contacts: [
            {
                contactId,
                fullName: data.full_name,
                imageLink: data.imageLink,
                locality: data.locality,
                topCompany: data.topCompany || data.top_company,
                experienceParsed: data.experienceParsed || data.experience_parsed,
                organizations: _.map(data.organizations, mapOrganization),
                headline: data.headline,
                linkedinHeaderCompany: data.linkedinHeaderCompany,
                linkedinHeaderJobTitle: data.linkedinHeaderJobTitle,
                socialLink: (data === null || data === void 0 ? void 0 : data.socialLink) || data.link,
                linkedinKey: data.linkedinCanonicalId,
                linkedin_user_id: data === null || data === void 0 ? void 0 : data.linkedin_user_id,
            },
        ],
    };
}
export function mapBulkSearchData(searchData, isPluginOpen) {
    return {
        metadata: {
            searchType: BULK_SEARCH_TYPE,
            requestId: uuid(),
            parserType: searchData.metadata.parserType,
            isUnifiedParser: searchData.metadata.isUnifiedParser,
            isUnifiedParserEnabled: searchData.metadata.isUnifiedParserEnabled,
            sourcePlatform: searchData.source_platform,
            url: searchData.url,
            isPluginOpen,
            sessionId: searchData.sessionId,
            platform: searchData.metadata.platform,
            indicatorNotFound: searchData.metadata.indicatorNotFound,
            indicatorSelector: searchData.metadata.indicatorSelector,
            parserCategory: searchData.metadata.parserCategory,
            contactsOnPage: searchData.metadata.contactsOnPage,
            contactsParsed: searchData.metadata.contactsParsed,
        },
        contacts: searchData.contacts.map(contact => {
            const contactId = uuid();
            return {
                contactId,
                fullName: contact.fullName,
                imageLink: contact.imageLink,
                locality: contact.geoRegion,
                socialLink: contact.socialLink,
                organizations: contact.currentPositions.map(mapCurrentPosition),
                headline: contact.headline,
                linkedinHeaderCompany: contact.linkedinHeaderCompany,
                linkedinHeaderJobTitle: contact.linkedinHeaderJobTitle,
                linkedinKey: contact.linkedinCanonicalId,
            };
        }),
    };
}
